import { getEventIds, getEventOthersFilter, getPeriodsState } from '../reducers/analyticsApp';
import { createOthersQuery, createQuery, getTypeField } from '../utils/event/createQueries';
import { toEventResult, toRange } from './eventConverter';
import { createCharArray } from '../actions/common';

export const createEventsQueries = (state) => {
  const ids = getEventIds(state);
  const getPeriodsQueries = (id) =>
    getPeriodsState(state, id)
      .periods.filter((period) => !!period.from.length)
      .map((period) => createQuery(state, id, period));

  const getSplitWithOtherQueries = (id) => {
    const others = getEventOthersFilter(state, id);

    const splitQuery = createQuery(state, id);
    const othersQuery = createOthersQuery(state, id, others);
    return [splitQuery, othersQuery];
  };

  const getQueries = (id) => {
    const others = getEventOthersFilter(state, id);
    if (!others) {
      return [createQuery(state, id)].concat(getPeriodsQueries(id));
    }
    return getSplitWithOtherQueries(id);
  };

  return ids.flatMap((id) => getQueries(id));
};

export const addCachedLabel = (result) => ({
  ...result,
  info: {
    ...result.info,
    eventName: `${result.info.eventName} [cached]`,
  },
});

export const getEventsInfo = (state) => {
  const charsArray = createCharArray(state);
  const getType = (field) => getTypeField(field, state);

  return { charsArray, getType };
};

export const fromEventResponse = (response, queries, eventsInfo) => {
  const { charsArray, getType } = eventsInfo;
  const isEventsWithOthers =
    charsArray.length > 1 && charsArray.some((char) => char.includes('Others'));
  const result = response
    .map((resultItem, index) =>
      toEventResult(resultItem, queries[index], charsArray[index], getType, isEventsWithOthers)
    )
    .map((resultItem, index) =>
      !response[index].cached ? resultItem : addCachedLabel(resultItem)
    );
  const options = toRange(result[0].info);

  return {
    result,
    options,
  };
};
